/**
 * API client for comment system
 */

import { apiClient, handleApiError } from './apiClient';

export interface CommentItem {
  id: string;
  targetType: string;
  targetId: string;
  author: string;
  authorName: string;
  content: string;
  createdAt: string;
}

export interface CommentCounts {
  [key: string]: number;
}

export async function fetchCommentCounts(): Promise<CommentCounts> {
  try {
    const response = await apiClient.get<{ data: CommentCounts }>('/comments/counts');
    return response.data.data;
  } catch (error) {
    return handleApiError(error, 'Failed to fetch comment counts');
  }
}

export async function fetchThread(
  targetType: string,
  targetId: string
): Promise<CommentItem[]> {
  try {
    const response = await apiClient.get<{ data: { comments: CommentItem[] } }>(
      `/comments/thread/${encodeURIComponent(targetType)}/${encodeURIComponent(targetId)}`
    );
    return response.data.data.comments;
  } catch (error) {
    return handleApiError(error, 'Failed to fetch comments');
  }
}

export async function fetchPageComments(page: string): Promise<CommentItem[]> {
  try {
    const response = await apiClient.get<{ data: CommentItem[] }>(
      `/comments/page/${encodeURIComponent(page)}`
    );
    return response.data.data;
  } catch (error) {
    return handleApiError(error, 'Failed to fetch page comments');
  }
}

export async function addComment(
  targetType: string,
  targetId: string,
  content: string
): Promise<CommentItem> {
  try {
    const response = await apiClient.post<{ data: CommentItem }>('/comments', {
      targetType,
      targetId,
      content,
    });
    return response.data.data;
  } catch (error) {
    return handleApiError(error, 'Failed to add comment');
  }
}

export async function deleteComment(id: string): Promise<void> {
  try {
    await apiClient.delete(`/comments/${encodeURIComponent(id)}`);
  } catch (error) {
    handleApiError(error, 'Failed to delete comment');
  }
}
